declare const STPadServerLibCommons: any;
declare const STPadServerLibDefault: any;

interface CommandBase {
    command: 'TOKEN_TYPE_REQUEST' | 'TOKEN_CMD_SEARCH_FOR_PADS' | 'TOKEN_CMD_OPEN_PAD' | 'TOKEN_CMD_CLOSE_PAD' | 'TOKEN_CMD_SIGNATURE_START'
        | 'TOKEN_CMD_SIGNATURE_CANCEL' | 'TOKEN_CMD_SIGNATURE_RETRY' | 'TOKEN_CMD_SIGNATURE_CONFIRM' | 'TOKEN_CMD_SIGNATURE_SIGN_DATA'
        | 'TOKEN_CMD_SIGNATURE_IMAGE' | 'TOKEN_CMD_SIGNING_CERT' | 'TOKEN_CMD_SIGNATURE_POINT' | 'TOKEN_CMD_SELECTION_DIALOG'
        | 'TOKEN_CMD_SELECTION_CHANGE' | 'TOKEN_CMD_SELECTION_CONFIRM' | 'TOKEN_CMD_SIGNATURE_STOP' | 'TOKEN_CMD_SELECTION_CANCEL'
        | 'TOKEN_CMD_DISCONNECT' | 'TOKEN_CMD_ERROR' | 'TOKEN_PARAM_CONNECTED_PADS' | 'TOKEN_PARAM_LAYOUT_ID' | 'TOKEN_PARAM_TEXT_BLOCKS'
        | 'TOKEN_PARAM_TEXT' | 'TOKEN_PARAM_WIDTH' | 'TOKEN_PARAM_HEIGHT' | 'TOKEN_PARAM_FONT_NAME' | 'TOKEN_PARAM_FONT_STYLE'
        | 'TOKEN_PARAM_MAX_FONT_SIZE' | 'TOKEN_PARAM_FONT_SIZE_ID' | 'TOKEN_PARAM_CONSTANT' | 'TOKEN_PARAM_FIELD_LIST'
        | 'TOKEN_PARAM_FIELD_ID' | 'TOKEN_PARAM_FIELD_TEXT' | 'TOKEN_PARAM_FIELD_CHECKED' | 'TOKEN_PARAM_FIELD_REQUIRED';
    returnCode: number;
}

interface CommandBaseResponse extends CommandBase {
    returnCode: number;
}
interface CommandBaseError extends CommandBase {
    errorCode: number;
    errorMessage: number;
}

interface SearchForPadsCommandResponse extends CommandBaseResponse {
    foundPads: Array<{
        capabilities: string,
        comPort: string
        connectionType: string
        firmwareVersion: string
        index: string
        ipAddress: string
        serialNumber: string
        type: number
    }>;
    command: 'TOKEN_CMD_SEARCH_FOR_PADS';
}

interface PadInfoCommandResponse extends CommandBaseResponse {
    padInfo: {
        dialogHeight: number;
        dialogWidth: number;
        displayHeight: number;
        displayResolution: number;
        displayWidth: number;
        samplingRate: number;
        xResolution: number;
        yResolution: number;
    };
    command: 'TOKEN_CMD_OPEN_PAD';
}

export class SignotecNativeCaptureService {
    private signotecConnectionOpened: boolean = false;
    private signotecPadOpened: boolean = false;
    private signotecPadSignatureStarted: boolean = false;
    private readonly SIGNOTEC_WEBSOCKET_URI = 'wss://local.signotecwebsocket.de:49494';

    public createConnectionAndOpenFirstPad(boundingRectEl: HTMLElement, canvas: HTMLCanvasElement, drawCb?: (x: number, y: number, p: number) => void) {
        return new Promise<void>(((resolve, reject) => {
            try {
                STPadServerLibCommons.createConnection(this.SIGNOTEC_WEBSOCKET_URI, () => {
                    this.signotecConnectionOpened = true;
                    const searchForPadsRequest = new STPadServerLibDefault.Params.searchForPads();
                    STPadServerLibDefault.searchForPads(searchForPadsRequest).then((searchForPadsResponse: SearchForPadsCommandResponse) => {
                        if (searchForPadsResponse.foundPads.length > 0) {
                            const openPadRequest = new STPadServerLibDefault.Params.openPad(0);
                            STPadServerLibDefault.openPad(openPadRequest).then((padInfo: PadInfoCommandResponse) => {
                                this.signotecPadOpened = true;
                                STPadServerLibCommons.handleNextSignaturePoint = (x: number, y: number, p: number) => {
                                    // signotec pad specific settings
                                    const offsetX = 60;
                                    const offsetY = 110;

                                    const width = boundingRectEl.clientWidth / (padInfo.padInfo.xResolution - offsetX);
                                    const height = boundingRectEl.clientHeight / (padInfo.padInfo.yResolution - offsetY);
                                    const ctx = canvas.getContext('2d');

                                    if (ctx === null) {
                                        throw new Error('Canvas 2d Context not resolvable');
                                    }

                                    if (p === 0) {
                                        this.drawStrokeStartPoint(ctx, (x - offsetX) * width, (y - offsetY) * height);
                                    } else {
                                        this.drawStrokePoint(ctx, (x - offsetX) * width, (y - offsetY) * height);
                                    }

                                    if (drawCb !== undefined) {
                                        drawCb(x, y, p);
                                    }
                                };
                                const startSignatureRequest = new STPadServerLibDefault.Params.startSignature();
                                STPadServerLibDefault.startSignature(startSignatureRequest).then(() => {
                                    this.signotecPadSignatureStarted = true;
                                    resolve();
                                }, (error: CommandBaseError) => {
                                    // error occured
                                    this.closeConnection();
                                    reject({
                                        msg: 'Fehler beim Starten des Signotec Pads.',
                                        error
                                    });
                                });
                            }, (error: CommandBaseError) => {
                                // error occured
                                this.closeConnection();
                                reject({
                                    msg: 'Fehler beim Adressieren des Signotec Pads.',
                                    error
                                });
                            });
                        } else {
                            // no pad has been found
                            this.closeConnection();
                            reject({
                                msg: 'Kein Signotec Pad gefunden'
                            });
                        }
                    }, (error: CommandBaseError) => {
                        // error occured
                        this.closeConnection();
                        reject({
                            msg: 'Fehler beim Suchen verfügbarer Signotec Pads.',
                            error
                        });
                    });
                }, () => {
                    // connection closed
                }, () => {
                    // ignore connection error
                });
            } catch (error) {
                // connection failed or no pad available
                reject({
                    msg: 'Fehler beim Verbindungsaufbau oder kein Pad verfügbar',
                    error
                });
            }
        }));
    }

    public closeConnection() {
        this.signotecPadSignatureStarted = false;
        let preparationObversable = new Promise<void>((resolve) => {
            resolve();
        });
        if (this.signotecPadOpened) {
            // 1. close open pad connection
            const params = new STPadServerLibDefault.Params.closePad(0);
            preparationObversable = STPadServerLibDefault.closePad(params);
        }
        if (this.signotecConnectionOpened) {
            preparationObversable.then(() => {
                this.signotecPadOpened = false;
                // 2. close the connection
                STPadServerLibCommons.destroyConnection();
                this.signotecConnectionOpened = false;
            });
        }
    }

    /**
     * Draws a stroke start point into the canvas
     */
    drawStrokeStartPoint(canvasContext: CanvasRenderingContext2D, softCoordX: number, softCoordY: number) {
        // open new stroke's path
        canvasContext.beginPath();
        canvasContext.arc(softCoordX, softCoordY, 0.1, 0, 2 * Math.PI, true);
        canvasContext.fill();
        canvasContext.stroke();
        canvasContext.moveTo(softCoordX, softCoordY);
    }

    /**
     * Draws a stroke point into the canvas
     */
    drawStrokePoint(canvasContext: CanvasRenderingContext2D, softCoordX: number, softCoordY: number) {
        // continue after start or not start point
        canvasContext.lineTo(softCoordX, softCoordY);
        canvasContext.stroke();
    }

}
